import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import AgentSettingsForm from './AgentSettingsForm';
import i18n from 'i18n';

interface AgentSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeAgentId: number;
}

const AgentSettingsModal: React.FC<AgentSettingsModalProps> = React.memo((
    {
        modalOpen,
        closeModal,
        activeAgentId,
    },
) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_agent_settings.text')}
        entityId={activeAgentId}
        entityIdPropName="agentId"
        FormComponent={AgentSettingsForm}
    />
));

export default AgentSettingsModal; 